import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TutorInvitation.css';

const TutorInvitation = () => {
  const navigate = useNavigate();

  const handleJoinNow = () => {
    navigate('/profile');
  };

  return (
    <div className="tutor-invitation-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Join BagpipeBlasphemy as a Tutor</h1>
          <p className="hero-subtitle">Where Technology Meets Tradition</p>
          <div className="hero-description">
            <p>
              Welcome to BagpipeBlasphemy, the platform where the timeless art of bagpiping meets cutting-edge technology. 
              We're building a global community of bagpipe tutors, connecting passionate instructors with students worldwide. 
              Whether you're teaching traditional piobaireachd in Edinburgh, guiding beginners online from Sydney, or coaching 
              pipe bands in Chicago, your expertise belongs here. Join us to share your skills, leverage our innovative AI sheet 
              music generator, and inspire the next generation of pipers.
            </p>
          </div>
          <button className="cta-button primary" onClick={handleJoinNow}>
            Join Now
          </button>
        </div>
      </section>

      {/* Why Join Section */}
      <section className="why-join-section">
        <div className="section-content">
          <h2 className="section-title">Why Join BagpipeBlasphemy?</h2>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">🌍</div>
              <h3>Connect with Students Worldwide</h3>
              <ul>
                <li>Reach learners from every continent, from Glasgow to Tokyo.</li>
                <li>Offer lessons in-person, online, or both, tailored to your teaching style.</li>
                <li>Grow your student base with our user-friendly search and discovery tools.</li>
              </ul>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">🎯</div>
              <h3>Showcase Your Craft</h3>
              <ul>
                <li>Create a detailed profile highlighting your experience, specialties (e.g., beginner lessons, competition prep, traditional tunes), and teaching approach.</li>
                <li>Share your love for bagpiping with a vibrant community of players and learners.</li>
              </ul>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">🤖</div>
              <h3>Enhance Lessons with AI Technology</h3>
              <ul>
                <li>Use our AI sheet music generator to create custom tunes and exercises for your students, blending tradition with innovation.</li>
                <li>Save time and enrich lessons with on-demand sheet music designed for your teaching needs.</li>
                <li>Stay at the forefront of music education with tools that honor the pipes' heritage.</li>
              </ul>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">💰</div>
              <h3>Free and Simple to Join</h3>
              <ul>
                <li>Listing your profile is free during our launch phase—no upfront costs.</li>
                <li>Set your own rates and schedule with full flexibility.</li>
                <li>Manage lessons and student communications effortlessly through our platform.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>



      {/* How to Get Started Section */}
      <section className="getting-started-section">
        <div className="section-content">
          <h2 className="section-title">How to Get Started</h2>
          
          <div className="steps-container">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3>Sign Up</h3>
              <p>Create your free tutor account in just a few minutes.</p>
            </div>

            <div className="step-card">
              <div className="step-number">2</div>
              <h3>Build Your Profile</h3>
              <p>Add your teaching details, availability, and a bio that reflects your passion for the pipes.</p>
            </div>

            <div className="step-card">
              <div className="step-number">3</div>
              <h3>Engage with Students</h3>
              <p>Start connecting with learners eager to study with you.</p>
            </div>
          </div>

          <div className="cta-container">
            <button className="cta-button primary large" onClick={handleJoinNow}>
              Join Now
            </button>
          </div>
        </div>
      </section>

      {/* Heart of BagpipeBlasphemy Section */}
      <section className="heart-section">
        <div className="section-content">
          <h2 className="section-title">The Heart of BagpipeBlasphemy</h2>
          <div className="heart-content">
            <p>
              Bagpipes carry centuries of tradition, from the Highlands of Scotland to pipe bands across the globe. 
              At BagpipeBlasphemy, we celebrate this legacy while embracing technology to make learning more accessible 
              and inspiring. As a tutor, you'll play a vital role in preserving the art of bagpiping and passing it on 
              to future generations.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="section-content">
          <h2 className="section-title">Frequently Asked Questions</h2>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Is there a cost to join?</h3>
              <p>
                No! Listing your profile is free during our launch phase. You set your own lesson rates, with no upfront fees.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do I need to teach online?</h3>
              <p>
                Not at all. You can offer in-person lessons, online lessons, or a mix—whatever suits your style.
              </p>
            </div>

            <div className="faq-item">
              <h3>How does the AI sheet music generator work?</h3>
              <p>
                Our AI creates custom bagpipe sheet music based on your specifications, perfect for exercises, practice tunes, 
                or new compositions. As a tutor, you'll have access to this tool to enhance your teaching.
              </p>
            </div>

            <div className="faq-item">
              <h3>How do students find me?</h3>
              <p>
                Students can search for tutors by location, teaching mode, specialties, and more. Your profile will be visible 
                to learners worldwide, and we'll promote top tutors on our platform.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="final-cta-section">
        <div className="section-content">
          <h2 className="section-title">Ready to Blend Tradition with Technology?</h2>
          <p className="final-cta-text">
            Join BagpipeBlasphemy today and become part of a global community dedicated to the art of bagpiping. 
            Whether you're teaching beginners or mentoring advanced pipers, your expertise will shine here.
          </p>
          <button className="cta-button primary large" onClick={handleJoinNow}>
            Sign Up Now
          </button>
        </div>
      </section>
    </div>
  );
};

export default TutorInvitation; 